import React from 'react';
import logo from '../assets/logo.png'
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FiCopy } from "react-icons/fi";
import { LuWallet2, LuArrowUpFromLine, LuArrowDownToLine } from "react-icons/lu";
import { AiOutlinePlus } from "react-icons/ai";
import { BiCoin } from "react-icons/bi";
import { GoGraph } from "react-icons/go";

import TelegramNavigation from '../components/TelegramNavigation'
import polygonBg from '../assets/polygonBg.png'
import usdt from '../assets/usdt.png'
import usdc from '../assets/usdc.png'
import flagImage from '../assets/countries.webp'



const CryptoWallet = () => {
  return (
    <div className="bg-tgBackground text-white font-sans min-h-screen w-[100%] flex flex-col items-center p-4">
      {/* Header */}
      <div className="w-full max-w-md  rounded-lg p-1 shadow-md">
        <div className="flex justify-between items-center">
          <div className="bg-tgLight flex items-center justify-center w-9 h-9" style={{ borderRadius: '100%' }}>
            <IoIosCloseCircleOutline className='text-lg' />
          </div>

          <div>
            <img src={logo} className='w-20' alt="Logo" />
          </div>

          <div className="bg-tgLight flex items-center justify-center w-9 h-9" style={{ borderRadius: '100%' }}>
            <p className='mt-[-17px] text-xl '>...</p>
          </div>
        </div>





        {/* Balance */}
        <div className="text-center my-6">
          <div className='flex justify-center items-center'>
            <div className='w-7 h-7 mr-3  flex items-center justify-center' style={{ backgroundColor: '#061d3a', borderRadius: '50%', color: '#0b56c8' }}><LuWallet2 className='' /></div>
            <div className="text-xxl font-black"> 970.9<span className="text-md">USD</span></div>
          </div>
          <div className="flex justify-center items-center font-bold" style={{ fontSize: '20px' }}>
            <p className="mr-2">0xEa9c...f5BC</p>
            <FiCopy className='text-md' />
          </div>
        </div>


        {/* Action Buttons */}
        <div className="flex justify-between space-x-4 mt-10 font-extrabold bg-tgLight py-5 px-4 rounded-xl">
          <button className="flex items-center justify-center text-md space-x-2 flex-1 bg-active text-black py-1 rounded-lg">
            <LuArrowUpFromLine />
            <span>Send</span>
          </button>
          <button className="flex items-center justify-center text-md space-x-2 flex-1 bg-active text-black py-1 rounded-lg">
            <LuArrowDownToLine />
            <span>Receive</span>
          </button>
          <button className="flex items-center justify-center text-md space-x-2 flex-1 bg-active text-black py-1 rounded-lg">
            <AiOutlinePlus />
            <span>Buy</span>
          </button>
        </div>

      </div>


      {/* Buttons   */}
      <div className="w-full max-w-md flex p-2 font-bold">

        <button className="flex items-center justify-center bg-active text-black py-1 px-3 m-2 rounded-xl text-md">
          <BiCoin className='mr-1'/>
          <span> Crypto</span>
        </button>
        <button className="flex items-center justify-center  text-gray-100 py-1 px-3 m-2 rounded-xl text-md">
          <GoGraph className='mr-1'/>
          <span>Trade</span>
        </button>
        <button className="flex items-center justify-center  text-gray-100 py-1 px-3 m-2 rounded-xl text-md">
          <span>Points: <span style={{color:'white'}}>786</span></span>
        </button>
      </div>


      {/* Crypto Section */}
      <div className="w-full max-w-md bg-tgLight rounded-xl p-4 shadow-md">

        {/* Crypto List */}
        <div>

          <div className="flex font-bold">
            <div className='flex items-center'>
              <img src={polygonBg} className='w-7 h-7 mr-2' style={{ borderRadius: '50%' }} alt="" />
            </div>

            <div className="flex justify-between items-center w-[100%] border-b-[0.5px] border-[#515153]">
              <div className="">MATIC</div>
              <div className='text-right'>
                <div className='text-md'>20</div>
                <div className="text-gray-100 text-sm">$21.33</div>
              </div>
            </div>
          </div>


          <div className="flex font-bold">
            <div className='flex items-center'>
              <img src={usdc} className='w-7 h-7 mr-2' style={{ borderRadius: '50%' }} alt="" />
            </div>

            <div className="flex justify-between items-center w-[100%] border-b-[0.5px] border-[#515153]">
              <div className="">USDC</div>
              <div className='text-right'>
                <div className='text-md'>230</div>
                <div className="text-gray-100 text-sm">$229.99</div>
              </div>
            </div>
          </div>


          <div className="flex font-bold">
            <div className='flex items-center'>
              <img src={usdt} className='w-7 h-7 mr-2' style={{ borderRadius: '50%' }} alt="" />
            </div>

            <div className="flex justify-between items-center w-[100%] border-b-[0.5px] border-[#515153]">
              <div className="">USDT</div>
              <div className='text-right'>
                <div className='text-md'>50</div>
                <div className="text-gray-100 text-sm">$49.88</div>
              </div>
            </div>
          </div>

          {/* More Cryptocurrencies */}
        <button className="w-full text-center text-md mt-4 border-[0.5px] border-[#515153] rounded-lg">More Cryptocurrencies</button>
      
        </div>
      </div>

      <div className="w-full max-w-md mb-20 bg-tgLight rounded-xl mt-5 p-4 shadow-md flex">
        <div className='w-[60%]'>
          <h1 className='font-extrabold'>Off-Ramp</h1>
          <p className='text-md'>Convert Your Crypto to local Fiat currencies!</p>
        </div>
        <div>
          <img src={flagImage} className=' h-[120px]' alt="countries" />
        </div>

      </div>


      {/* <TelegramNavigation /> */}
    </div>

  );
};

export default CryptoWallet;
